import React from 'react';
import PropTypes from 'prop-types';
import StudentListTableRow from './StudentListTableRow';
import Student from './Student';
import SortableTable from '../SF/table/SortableTable';
import { getWord } from 'utils/tenant';
import { withLoader } from '../common/withLoader';
import { getTenantConfig } from 'utils/tenant';
import { hot } from 'react-hot-loader';
import SelectAllCheckbox from '../SF/table/SelectAllCheckbox';

class StudentListTable extends React.Component {

  get headers() {
    return [{
      content: <SelectAllCheckbox
        itemName={this.props.itemName}
        itemIds={this.props.students.map(item => item.id)}
        batchSelectAllEnabled={getTenantConfig('BATCH_ACTION_PROCESSING_ENABLED')}
        selectAllItems={this.props.selectAllStudents}
        selectedItemIds={this.props.selectedStudents} 
        totalItemCount={this.props.totalStudents}  />,
      collapsing: true
    }, {
      content: 'Name',
      sortValue: 'fullName'
    },
        ...(getTenantConfig('SUCCESS_SCORE_ENABLED') ? [{
            content: getWord('successScore'),
            sortValue: 'successScore'
        }] : []
    ), {
      content: 'Email',
      sortValue: 'email'
    }, {
      content: 'Phone'
    }, {
      content: getWord('mobilePhone')
    }];
  }

  renderStudent = (student, index) =>
    <StudentListTableRow 
      getStudentFolderLink={this.props.getStudentFolderLink}
      getSuccessScoreRange={this.props.getSuccessScoreRange}
      key={index}
      selectStudent={(checked) => this.props.selectStudent(checked, [student.id])}
      student={new Student(student, this.props.userCanSeeSuccessScore, this.props.allowPreferredEmail)}
      studentIsSelected={this.props.selectedStudents.findIndex(
        selectedItemId => selectedItemId === student.id) > -1} />

  render() {
    return <SortableTable 
      columnToSort={this.props.columnToSort}
      headers={this.headers}
      itemName={this.props.itemName}
      items={this.props.students}
      itemsPerPage={this.props.studentsPerPage}
      onSortChange={this.props.onSortChange}
      onPageChange={this.props.onPageChange}
      renderItem={this.renderStudent}
      sortDirection={this.props.sortDirection}
      start={this.props.start}
      totalItems={this.props.totalStudents}
      totalSelected={this.props.selectedStudents.length} />
  }

}

StudentListTable.defaultProps = {
  columnToSort: 'fullName',
  sortDirection: 'ASC'
};

StudentListTable.propTypes = {
  allowPreferredEmail: PropTypes.bool.isRequired,
  columnToSort: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  getStudentFolderLink: PropTypes.func.isRequired,
  getSuccessScoreRange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
  selectAllStudents: PropTypes.func.isRequired,
  selectedStudents: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectStudent: PropTypes.func.isRequired,
  sortDirection: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  students: PropTypes.array.isRequired,
  studentsPerPage: PropTypes.number.isRequired,
  totalStudents: PropTypes.number.isRequired,
  userCanSeeSuccessScore: PropTypes.bool.isRequired
};

export default hot(module)(withLoader(StudentListTable));
